/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroup } from './UserGroup';
import {
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
} from './UserGroup';

/**
 * Representation of a User Group List
 * @export
 * @interface UserGroupList
 */
export interface UserGroupList {
    /**
     * List of user groups
     * @type {Array<UserGroup>}
     * @memberof UserGroupList
     */
    userGroups?: Array<UserGroup>;
    /**
     * Total number
     * @type {number}
     * @memberof UserGroupList
     */
    totalNumber?: number;
    /**
     * Page size
     * @type {number}
     * @memberof UserGroupList
     */
    pageSize?: number;
    /**
     * Number of pages
     * @type {number}
     * @memberof UserGroupList
     */
    numberOfPages?: number;
    /**
     * Current page
     * @type {number}
     * @memberof UserGroupList
     */
    currentPage?: number;
}

/**
 * Check if a given object implements the UserGroupList interface.
 */
export function instanceOfUserGroupList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserGroupListFromJSON(json: any): UserGroupList {
    return UserGroupListFromJSONTyped(json, false);
}

export function UserGroupListFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userGroups': !exists(json, 'userGroups') ? undefined : ((json['userGroups'] as Array<any>).map(UserGroupFromJSON)),
        'totalNumber': !exists(json, 'totalNumber') ? undefined : json['totalNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'numberOfPages': !exists(json, 'numberOfPages') ? undefined : json['numberOfPages'],
        'currentPage': !exists(json, 'currentPage') ? undefined : json['currentPage'],
    };
}

export function UserGroupListToJSON(value?: UserGroupList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userGroups': value.userGroups === undefined ? undefined : ((value.userGroups as Array<any>).map(UserGroupToJSON)),
        'totalNumber': value.totalNumber,
        'pageSize': value.pageSize,
        'numberOfPages': value.numberOfPages,
        'currentPage': value.currentPage,
    };
}

